/**
 * The v2 pages' code-split chunks, one loader per page. App.tsx builds each
 * page's `React.lazy` from these loaders, and v2 Home calls the same loaders
 * on idle to preload the chunks (useV2HomePrefetch). One loader per page, so
 * the preload and the route always fetch the same module.
 *
 * Kept out of App.tsx on purpose: Home is itself a lazy chunk, and importing
 * App.tsx from it would make a cycle back into the entry module.
 */
export const loadHomePage = () => import('../pages/home/Home');
export const loadSalesPage = () => import('../pages/sales/SalesPage');
export const loadProductsPage = () => import('../pages/products/ProductsPage');
export const loadReturnsPage = () => import('../pages/returns/ReturnsPage');
export const loadOrdersPage = () => import('../pages/orders/OrdersPage');
export const loadFinancesPage = () => import('../pages/finances/FinancesPage');
export const loadReportsLayout = () => import('../pages/reports/ReportsLayout');
export const loadSettingsPage = () => import('../pages/settings/SettingsPage');

/** The chunk behind each v2 frame route other than Home. */
export const V2_ROUTE_PRELOADERS = {
  '/sales': loadSalesPage,
  '/products': loadProductsPage,
  '/returns': loadReturnsPage,
  '/orders': loadOrdersPage,
  '/finances': loadFinancesPage,
  '/reports': loadReportsLayout,
  '/settings': loadSettingsPage,
} as const;
